var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { IdResource } from "../../../constants/IdResource";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
import { TextLoca } from "../../generic/text/TextLoca";
import { OfferRewardList } from "./OfferRewardList";
import { OfferRewardsHeader } from "./OfferRewardsHeader";
export var OfferRewards = function (props) {
    var isPurchased = props.isPurchased, locaKeyFlavour = props.locaKeyFlavour, rewards = props.rewards, idTooltipAnchor = props.idTooltipAnchor;
    var paymentCompletedClass = isPurchased ? "payment-completed" : IdStyles.Empty;
    var rewardsList = rewards.filter(function (val) { return val.id !== IdResource.Gold; });
    return (React.createElement("div", { className: "offer-body__rewards" },
        React.createElement(OfferRewardsHeader, __assign({}, props, { idTooltipAnchor: idTooltipAnchor })),
        React.createElement("div", { className: IdStyles.OfferRewardListBackground + " offer-body__reward-list-container " + paymentCompletedClass + " pos-rel" },
            React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "offer-body__reward-list" },
                React.createElement(OfferRewardList, { rewards: rewardsList, className: "offer-reward-item" })),
            locaKeyFlavour && (React.createElement(TextLoca, { id: locaKeyFlavour, className: IdStyles.TextBoldSecondary + " offer-body__reward-list-header flex flex--guts" })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferRewards.tsx
// module id = 961
// module chunks = 3